<div id="app" class="app app-content-full-height app-without-sidebar app-without-header">
  <div id="content" class="app-content p-0">
    <div class="pos pos-vertical pos-with-header">
      <div class="pos-container" [ngClass]="isMobile ? 'p-2' : 'p-5'">

        <app-header></app-header>

        <ng-container *ngIf="!isMobile">
          <div class="content__filter mb-3">

            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <span class="fs-3 mb-0 fw-bold me-3">Payment #{{ payment?.paymentNo }}</span>
                <div class="fs-4 fw-semibold badge text-white"
                     [class.bg-danger]="payment?.paymentStatus === 'VOIDED'"
                     [class.bg-success]="payment?.paymentStatus === 'PAID'">{{ payment?.paymentStatus | titlecase }}
                </div>
              </div>

              <div class="d-flex justify-content-center align-items-center">
                <button class="btn btn-lg btn-default fw-semibold mb-0 d-block py-3 text-black"
                        [routerLink]="['/payment-list']">
                  <i class="fa fa-arrow-left"></i>
                  Back to list
                </button>
                <button class="btn btn-lg btn-default fw-semibold mb-0 d-block py-3  ms-4"
                        (click)="reprintReceipt(); $event.stopPropagation()">
                  <i class="fa fa-print"></i>
                  Reprint Receipt
                </button>
                <button class="btn btn-lg fw-semibold mb-0 d-block py-3 text-white bg-danger ms-4"
                        *ngIf="payment?.paymentStatus === 'PAID'"
                        (click)="voidPayment(payment); $event.stopPropagation()">
                  <i class="fa fa-trash"></i>
                  Void Payment
                </button>
              </div>
            </div>
          </div>

          <div class="content__body">
            <table class="table table-bordered bg-white table">
              <ng-container *ngIf="payment?.paymentStatus === 'VOIDED'">
                <tr>
                  <th>Void By</th>
                  <td>{{ payment?.voidUser }}</td>
                </tr>
                <tr>
                  <th>Void Date</th>
                  <td>{{ payment?.voidDate | date: 'dd/MM/yy HH:mm' }}</td>
                </tr>
              </ng-container>
              <tr>
                <th class="w-25">Paid Date</th>
                <td>{{ payment?.creationTime | date: 'dd/MM/yy HH:mm' }}</td>
              </tr>
              <tr>
                <th>Receipt No</th>
                <td>
                  <a
                    class="p-0" [routerLink]="['/payment-detail']"
                    [queryParams]="{paymentId: payment?.id}">{{ payment?.paymentNo }}</a>
                </td>
              </tr>

              <tr>
                <th>Items</th>
                <td>
                  <table class="table table-striped table-bordered">
                    <thead>
                    <tr>
                      <th class="fw-bold w-50px">No</th>
                      <th class="fw-bold w-250px">Item</th>
                      <th class="fw-bold w-100px text-right">Price</th>
                      <th class="fw-bold w-50px text-right">Qty</th>
                      <th class="fw-bold w-100px text-right">Subtotal</th>
                      <th class="fw-bold w-100px text-right">Disc</th>
                      <th class="fw-bold w-100px text-right">Rounding</th>
                      <th class="fw-bold w-100px text-right">Total</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let oi of payment?.paymentOrderItems; index as i; let last=last">
                      <td class="w-10px">{{ i+1 }}</td>
                      <td class="w-250px">
                        {{ oi?.orderItem.name }}
                        <ng-container *ngIf="oi.varianceModel.length > 0">
                          <br>
                          <ng-container *ngFor="let v of oi.varianceModel; let last=last">
                            <ng-container *ngFor="let opt of v.options;">
                              - {{ opt.name }} +{{ opt.price | number: '1.2' }}<br />
                            </ng-container>
                          </ng-container>
                        </ng-container>
                      </td>
                      <td class="w-100px text-right">{{ oi?.orderItem.price | number: '1.2' }}</td>
                      <td class="w-50px text-right">x{{ oi?.quantity }}</td>
                      <td class="w-100px text-right">{{ oi?.subtotal | number: '1.2' }}</td>
                      <td class="w-100px text-right">{{ oi?.discount | number: '1.2' }}</td>
                      <td class="w-100px text-right">{{ oi?.rounding | number: '1.2' }}</td>
                      <td class="w-100px text-right">{{ oi?.total | number: '1.2' }}</td>
                    </tr>
                    </tbody>
                  </table>
                </td>
              </tr>

              <tr>
                <th>Method</th>
                <td>
                  <div class="d-flex flex-column">
                    <!-- Staff Meal payment if used -->
                    <div class="d-flex flex-column" *ngIf="payment?.staffMealAmount > 0">
                      <div class="d-flex flex-row align-items-center mb-1">
                        <i class="fa fa-utensils me-2 text-success"></i>
                        <span class="text-success fw-semibold">Staff Meal: RM {{ payment?.staffMealAmount | number: '1.2' }}</span>
                      </div>
                      <div class="text-muted small ms-4" *ngIf="payment?.staffMealStaff">
                        Staff Reference: {{payment?.staffMealStaff?.staffNo}}
                      </div>
                      <div class="text-muted small ms-4" *ngIf="payment?.staffMealPreviousBalance !== null && payment?.staffMealPreviousBalance !== undefined">
                        Balance Before: RM{{payment?.staffMealPreviousBalance | number: '1.2'}}
                      </div>
                      <div class="text-muted small ms-4" *ngIf="payment?.staffMealNewBalance !== null && payment?.staffMealNewBalance !== undefined">
                        Balance After: RM{{payment?.staffMealNewBalance | number: '1.2'}}
                      </div>
                    </div>
                    <!-- Voucher payment if used -->
                    <div class="d-flex flex-column" *ngIf="payment?.voucherAmount > 0" [class.mt-2]="payment?.staffMealAmount > 0">
                      <div class="d-flex flex-row align-items-center mb-1">
                        <i class="fa fa-tag me-2 text-warning"></i>
                        <span class="text-warning fw-semibold">Voucher: RM {{ payment?.voucherAmount | number: '1.2' }}</span>
                      </div>
                      <div class="text-muted small ms-4" *ngIf="payment?.voucherCode">
                        Code: {{payment?.voucherCode}}
                      </div>
                    </div>
                    <!-- Primary/Secondary payment method -->
                    <div class="d-flex flex-row align-items-center" [class.mt-2]="payment?.staffMealAmount > 0 || payment?.voucherAmount > 0" *ngIf="payment?.paidAmount > 0 || (!payment?.staffMealAmount && !payment?.voucherAmount)">
                      <img src="{{payment?.paymentMethod?.logoUrl}}"
                           class="h-15px me-2"
                           *ngIf="payment?.paymentMethod?.logoUrl">
                      <span>{{ payment?.paymentMethod?.name }}</span>
                      <span *ngIf="payment?.staffMealAmount > 0 && payment?.paidAmount > 0" class="ms-1">: RM {{ payment?.paidAmount | number: '1.2' }}</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr *ngIf="payment?.paymentMethodUpdatedBy">
                <th>Method Update Info</th>
                <td>
                  <div class="small">
                    <div><span class="fw-bold">Original:</span> {{ payment?.previousPaymentMethod?.name }}</div>
                    <div><span class="fw-bold">Updated By:</span> {{ payment?.paymentMethodUpdatedBy }}</div>
                    <div><span class="fw-bold">Date:</span> {{ payment?.paymentMethodUpdatedAt | date:'dd/MM/yy HH:mm' }}</div>
                    <div><span class="fw-bold">Reason:</span> {{ payment?.paymentMethodUpdateRemark }}</div>
                  </div>
                </td>
              </tr>
              <tr *ngIf="payment?.paymentMethod.name !== 'Cash'">
                <th>eWallet Ref</th>
                <td>{{ payment?.ewalletReferenceNo }}</td>
              </tr>
              <tr>
                <th>Table</th>
                <td>
                <span class="w-100px text-right d-block p-0">
                {{ payment?.tableMerchant?.name }}
                </span>
                </td>
              </tr>

              <tr *ngIf="payment?.paxNo > 0">
                <th>No of Pax</th>
                <td>
                <span class="w-100px text-right d-block p-0">
                {{ payment?.paxNo }}
                </span>
                </td>
              </tr>

              <tr>
                <th>Subtotal</th>
                <td>
                <span class="w-100px text-right d-block p-0">
                {{ payment?.totalAmount | number: '1.2' }}
                </span>
                </td>
              </tr>
              <tr>
                <th>SST</th>
                <td>
                <span class="text-left fst-italic d-block p-0" *ngIf="payment?.inclusiveTax > 0">
                (Inclusive of 6% SST: RM{{ payment?.inclusiveTax | number: "1.2" }})
                </span>
                  <span class="w-100px text-right d-block p-0" *ngIf="!payment?.inclusiveTax">
                {{ payment?.tax1Amount | number: '1.2' }}
                </span>
                </td>
              </tr>
              <tr>
                <th>Serv Charge</th>
                <td>
                <span class="w-100px text-right d-block p-0">
                {{ payment?.tax2Amount | number: '1.2' }}
                </span>
                </td>
              </tr>

              <tr *ngIf="payment?.chargesAmount > 0">
                <th>Delivery Charge</th>
                <td>
                <span class="w-100px text-right d-block p-0">
                {{ payment?.chargesAmount | number: '1.2' }}
                </span>
                </td>
              </tr>

              <tr *ngIf="payment?.discountAmount > 0">
                <th> Discount</th>
                <td>
                <span class="w-100px text-right d-block p-0">
                  -{{ payment?.discountAmount | number: '1.2' }}
                </span>
                  <span class="w-100px text-right d-block p-0 text-muted"> *{{ payment?.discountRemarks }}</span>
                </td>
              </tr>
              <tr *ngIf="payment?.discountItemAmount > 0">
                <th> Discount Item</th>
                <td>
                <span class="w-100px text-right d-block p-0">
                  -{{ payment?.discountItemAmount | number: '1.2' }}
                </span>

                </td>
              </tr>
              <tr *ngIf="payment?.appliedMembershipPoint > 0">
                <th> Cashback Redeems <br>
                  <span class="text-muted small">{{ payment?.membership?.name }}</span> <br>
                  <span class="text-muted small">{{ payment?.membership?.phoneNo }}</span>
                </th>
                <td>
                <span class="w-100px text-right d-block p-0">
                  -{{ payment?.appliedMembershipPoint | number: '1.2' }}
                </span>
                </td>
              </tr>
              <tr *ngIf="payment?.tipsAmount > 0">
                <th>Tips</th>
                <td>
                <span class="w-100px text-right d-block p-0">
                {{ payment?.tipsAmount | number: '1.2' }}
                </span>
                </td>
              </tr>
              <tr>
                <th>Rounding</th>
                <td>
                <span class="w-100px text-right d-block p-0">
                {{ payment?.roundingAmount | number: '1.2' }}
                </span>
                </td>
              </tr>
              <tr>
                <th>Net</th>
                <td>
                <span class="w-100px text-right d-block p-0">
                {{ payment?.netAmount | number: '1.2' }}
                </span>
                </td>
              </tr>
              <tr>
                <th>Paid</th>
                <td>
                <span class="w-100px text-right d-block p-0">
                {{ payment?.paidAmount | number: '1.2' }}
                </span>
                </td>
              </tr>
              <tr>
                <th>Change</th>
                <td>
                <span class="w-100px text-right d-block p-0">
                {{ payment?.changeAmount | number: '1.2' }}
                </span>
                </td>
              </tr>

              <tr *ngIf="payment?.membershipPoint > 0">
                <th>Cashback Received
                  <ng-container *ngIf="payment?.membership">
                    <br>
                    <span class="text-muted small">{{ payment?.membership?.name }}</span> <br>
                    <span class="text-muted small">{{ payment?.membership?.phoneNo }}</span>
                  </ng-container>
                </th>
                <td>
                <span class="w-100px text-right d-block p-0">
                {{ payment?.membershipPoint | number: '1.2' }}
                </span>
                </td>
              </tr>


            </table>
          </div>
        </ng-container>
        <ng-container *ngIf="isMobile">
          <div class="content__filter mb-3">
            <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
              <div class="d-flex align-items-start align-items-md-center mb-3 mb-md-0">
                <span class="fs-5 mb-0 fw-bold me-3">Payment #{{ payment?.paymentNo }}</span>
                <div class="fs-6 fw-semibold badge text-white"
                     [class.bg-danger]="payment?.paymentStatus === 'VOIDED'"
                     [class.bg-success]="payment?.paymentStatus === 'PAID'">
                  {{ payment?.paymentStatus | titlecase }}
                </div>
              </div>
              <div class="d-flex flex-row justify-content-center align-items-start align-items-md-center">
                <button class="btn btn-sm btn-default fw-semibold py-2 text-black me-2"
                        [routerLink]="['/payment-list']">
                  <i class="fa fa-arrow-left"></i> Back to list
                </button>
                <button class="btn btn-sm btn-default fw-semibold py-2 me-2"
                        (click)="reprintReceipt(); $event.stopPropagation()">
                  <i class="fa fa-print"></i> Reprint Receipt
                </button>
                <button class="btn btn-sm fw-semibold py-2 text-white bg-danger"
                        *ngIf="payment?.paymentStatus === 'PAID'"
                        (click)="voidPayment(payment); $event.stopPropagation()">
                  <i class="fa fa-trash"></i> Void Payment
                </button>
              </div>
            </div>
          </div>

          <div class="content__body">
            <table class="table table-bordered bg-white">
              <ng-container *ngIf="payment?.paymentStatus === 'VOIDED'">
                <tr>
                  <th class="fs-6">Void By</th>
                  <td class="fs-6">{{ payment?.voidUser }}</td>
                </tr>
                <tr>
                  <th class="fs-6">Void Date</th>
                  <td class="fs-6">{{ payment?.voidDate | date: 'dd/MM/yy HH:mm' }}</td>
                </tr>
              </ng-container>
              <tr>
                <th class="w-25 fs-6">Paid Date</th>
                <td class="fs-6">{{ payment?.creationTime | date: 'dd/MM/yy HH:mm' }}</td>
              </tr>
              <tr>
                <th class="fs-6">Receipt No</th>
                <td class="fs-6">
                  <a class="p-0 fs-6" [routerLink]="['/payment-detail']"
                     [queryParams]="{paymentId: payment?.id}">{{ payment?.paymentNo }}</a>
                </td>
              </tr>
              <tr>
                <th class="fs-6">Items</th>
                <td class="fs-6">
                  <div class="p-0 d-flex flex-column">
                    <div class="d-flex flex-column mt-1">
                      <div *ngFor="let oi of payment?.paymentOrderItems; let last=last" class="card mb-2">
                        <div class="card-body">
                          <span class="fw-semibold d-block">{{ oi?.orderItem.name }}</span>
                          <ng-container *ngFor="let v of oi.varianceModel; let last=last">
                            <ng-container *ngFor="let opt of v.options;">
                              <span>- {{ opt.name }} +{{ opt.price | number: '1.2' }}</span><br *ngIf="!last" />
                            </ng-container>
                          </ng-container>
                          <div class="d-flex justify-content-between mt-2">
                            <span>Qty: x{{ oi?.quantity }}</span>
                            <span>Subtotal: {{ oi?.subtotal | number: '1.2' }}</span>
                          </div>
                          <div class="d-flex justify-content-between">
                            <span>Disc: {{ oi?.discount | number: '1.2' }}</span>
                            <span>Tax: {{ oi?.tax | number: '1.2' }}</span>
                          </div>
                          <div class="d-flex justify-content-between">
                            <span>Rounding: {{ oi?.rounding | number: '1.2' }}</span>
                            <span>Total: {{ oi?.total | number: '1.2' }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th class="fs-6">Method</th>
                <td class="fs-6 text-right">
                  <div class="d-flex flex-column align-items-end">
                    <!-- Staff Meal payment if used -->
                    <div class="d-flex flex-column align-items-end" *ngIf="payment?.staffMealAmount > 0">
                      <div class="d-flex align-items-center mb-1">
                        <i class="fa fa-utensils me-2 text-success"></i>
                        <span class="text-success fw-semibold">Staff Meal: RM {{ payment?.staffMealAmount | number: '1.2' }}</span>
                      </div>
                      <div class="text-muted small" *ngIf="payment?.staffMealStaff">
                        Staff Reference: {{payment?.staffMealStaff?.staffNo}}
                      </div>
                      <div class="text-muted small" *ngIf="payment?.staffMealPreviousBalance !== null && payment?.staffMealPreviousBalance !== undefined">
                        Balance Before: RM{{payment?.staffMealPreviousBalance | number: '1.2'}}
                      </div>
                      <div class="text-muted small" *ngIf="payment?.staffMealNewBalance !== null && payment?.staffMealNewBalance !== undefined">
                        Balance After: RM{{payment?.staffMealNewBalance | number: '1.2'}}
                      </div>
                    </div>
                    <!-- Voucher payment if used -->
                    <div class="d-flex flex-column align-items-end" *ngIf="payment?.voucherAmount > 0" [class.mt-2]="payment?.staffMealAmount > 0">
                      <div class="d-flex align-items-center mb-1">
                        <i class="fa fa-tag me-2 text-warning"></i>
                        <span class="text-warning fw-semibold">Voucher: RM {{ payment?.voucherAmount | number: '1.2' }}</span>
                      </div>
                      <div class="text-muted small" *ngIf="payment?.voucherCode">
                        Code: {{payment?.voucherCode}}
                      </div>
                    </div>
                    <!-- Primary/Secondary payment method -->
                    <div class="d-flex align-items-center" [class.mt-2]="payment?.staffMealAmount > 0 || payment?.voucherAmount > 0" *ngIf="payment?.paidAmount > 0 || (!payment?.staffMealAmount && !payment?.voucherAmount)">
                      <img src="{{payment?.paymentMethod?.logoUrl}}" class="h-35px me-2"
                           *ngIf="payment?.paymentMethod?.logoUrl">
                      <span>{{ payment?.paymentMethod?.name }}</span>
                      <span *ngIf="(payment?.staffMealAmount > 0 || payment?.voucherAmount > 0) && payment?.paidAmount > 0" class="ms-1">: RM {{ payment?.paidAmount | number: '1.2' }}</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr *ngIf="payment?.paymentMethodUpdatedBy">
                <th class="fs-6">Method Update Info</th>
                <td class="fs-6 text-right">
                  <div class="small d-flex flex-column align-items-end">
                    <div><span class="fw-bold">Original:</span> {{ payment?.previousPaymentMethod?.name }}</div>
                    <div><span class="fw-bold">Updated By:</span> {{ payment?.paymentMethodUpdatedBy }}</div>
                    <div><span class="fw-bold">Date:</span> {{ payment?.paymentMethodUpdatedAt | date:'dd/MM/yy HH:mm' }}</div>
                    <div><span class="fw-bold">Reason:</span> {{ payment?.paymentMethodUpdateRemark }}</div>
                  </div>
                </td>
              </tr>
              <tr *ngIf="payment?.paymentMethod.name !== 'Cash'">
                <th class="fs-6">eWallet Ref</th>
                <td class="fs-6 text-right">{{ payment?.ewalletReferenceNo }}</td>
              </tr>
              <tr>
                <th class="fs-6">Table</th>
                <td class="fs-6 text-right">{{ payment?.tableMerchant?.name }}</td>
              </tr>

              <tr *ngIf="payment?.paxNo > 0">
                <th class="fs-6">No of Pax</th>
                <td class="fs-6 text-right">{{ payment?.paxNo }}</td>
              </tr>
              <tr>
                <th class="fs-6">Subtotal</th>
                <td class="fs-6 text-right">{{ payment?.totalAmount | number: '1.2' }}</td>
              </tr>
              <tr>
                <th class="fs-6">SST</th>
                <td class="fs-6 text-right">{{ payment?.tax1Amount | number: '1.2' }}</td>
              </tr>
              <tr>
                <th class="fs-6">Serv Charge</th>
                <td class="fs-6 text-right">{{ payment?.tax2Amount | number: '1.2' }}</td>
              </tr>
              <tr *ngIf="payment?.chargesAmount > 0">
                <th class="fs-6">Delivery Charges</th>
                <td class="fs-6 text-right">{{ payment?.chargesAmount | number: '1.2' }}</td>
              </tr>
              <tr *ngIf="payment?.discountAmount > 0">
                <th class="fs-6">Discount</th>
                <td class="fs-6 text-right">-{{ payment?.discountAmount | number: '1.2' }} <br>
                  <span> *{{ payment?.discountRemarks }}</span>
                </td>
              </tr>
              <tr *ngIf="payment?.discountItemAmount > 0">
                <th class="fs-6">Discount Item</th>
                <td class="fs-6 text-right">-{{ payment?.discountItemAmount | number: '1.2' }} <br>
                </td>
              </tr>
              <tr *ngIf="payment?.appliedMembershipPoint > 0">
                <th class="fs-6"> Cashback Redeems
                  <br>
                  <span class="text-muted small">{{ payment?.membership?.name }}</span> <br>
                  <span class="text-muted small"> {{ payment?.membership?.phoneNo }}</span>
                </th>
                <td class="fs-6">
                <span class="text-right d-block p-0">
                  -{{ payment?.appliedMembershipPoint | number: '1.2' }}
                </span>
                </td>
              </tr>
              <tr *ngIf="payment?.tipsAmount > 0">
                <th class="fs-6">Tips</th>
                <td class="fs-6 text-right">{{ payment?.tipsAmount | number: '1.2' }}</td>
              </tr>
              <tr>
                <th class="fs-6">Rounding</th>
                <td class="fs-6 text-right">{{ payment?.roundingAmount | number: '1.2' }}</td>
              </tr>
              <tr>
                <th class="fs-6">Net</th>
                <td class="fs-6 text-right">{{ payment?.netAmount | number: '1.2' }}</td>
              </tr>
              <tr>
                <th class="fs-6">Paid</th>
                <td class="fs-6 text-right">{{ payment?.paidAmount | number: '1.2' }}</td>
              </tr>
              <tr>
                <th class="fs-6">Change</th>
                <td class="fs-6 text-right">{{ payment?.changeAmount | number: '1.2' }}</td>
              </tr>

              <tr *ngIf="payment?.membershipPoint > 0">
                <th class="fs-6">Cashback Received
                  <br>
                  <span class="text-muted small">
                    {{ payment?.membership?.name }}</span> <br>
                  <span class="text-muted small">
                    {{ payment?.membership?.phoneNo }}</span>
                </th>
                <td class="fs-6">
                <span class="text-right d-block p-0">
                {{ payment?.membershipPoint | number: '1.2' }}
                </span>
                </td>
              </tr>

            </table>
          </div>


        </ng-container>

      </div>
    </div>
  </div>
</div>
